import { Container } from "./styles";
import npmIcon from "../../assets/npm.svg"
import githubIcon from "../../assets/github-icon.svg"
import externalLinkIcon from "../../assets/external-link-icon.svg"
import ScrollAnimation from "react-animate-on-scroll";


export function Contributor(){
  return(
    <Container id="contributor">
      <h2>Contributors</h2>

      <div className="projects">

      <ScrollAnimation animateIn="flipInX">
        <div className="project">
          <a href="https://github.com/richardevcom/vue3-boilerplate" target="_blank" rel="noreferrer">
          <header>
          <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
          <div className="project-links">
          {/* <a href="https://www.npmjs.com/package/vue-composable-utils" target="_blank" rel="noreferrer">
                <img src={npmIcon} alt="npm" />
              </a> */}
            <a href="https://github.com/richardevcom/vue3-boilerplate" target="_blank" rel="noreferrer">
              <img src={githubIcon} alt="GitHub" />
            </a>
            {/* <a href="https://vue-composable-utils.netlify.app/" target="_blank" rel="noreferrer">
                <img src={externalLinkIcon} alt="Visitar site" />
              </a> */}
          </div>
          </header>
            </a>

          <div className="body">
            <h3>Vue 3 boilerplate - Vite, Pinia, Vue Router & Tailwind CSS</h3>
            <p>This boilerplate was created as part of my custom Vue 3 boilerpalte tutorial. It will help get you started developing with Vue 3 in Vite. The template uses Vue 3 script setup SFCs, check out the script setup docs to learn more. 👨‍💻.
            </p>
          </div>
          <footer>
            <ul className="tech-list">
              <li>Vue 3.2</li>
              <li>Pinia 2.0</li>
              <li>Router 4.1</li>
              <li>Tailwind CSS 3.1</li>
              <li>eslint 8.5</li>
              <li>prettier 2.5</li>
            </ul>
          </footer>
        </div>
      </ScrollAnimation>
      </div>
    </Container>
  );
}